<app-layout>
    <mat-toolbar class="page-header" role="heading">
        <h1>{{ 'EmployeeLoginReport' | translate: {Default: "Employee Login Report"} }}</h1>
    </mat-toolbar>

    <div class="content">
        <app-employee-login-report-data-grid></app-employee-login-report-data-grid>
    </div>
</app-layout>
